import emptySplitApi from "../utils/rtk";
import { CommonBody, PaymentPlanType } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};
type GetPaymentPlanResponse = {
  length: number;
  start: number;
  response_object: PaymentPlanType[];
  total_records: number;
};

export const paymentPlanApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPaymentPlan: builder.mutation<
      CommonResponseType & { data: GetPaymentPlanResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.getPaymentPlans,
        method: "POST",
        body,
      }),
    }),

    deletePaymentPlan: builder.query<
      CommonResponseType & { data: PaymentPlanType },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deletePaymentPlan}${id}/`,
        method: "DELETE",
      }),
    }),

    paymentPlanDetail: builder.query<
      CommonResponseType & { data: PaymentPlanType[] | null },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getPaymentPlanById}${id}/`,
        method: "GET",
      }),
    }),
    updatePaymentPlan: builder.mutation<
      CommonResponseType & { data: PaymentPlanType },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updatePaymentPlan}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    addPaymentPlan: builder.mutation<
      CommonResponseType & { data: PaymentPlanType },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.addPaymentPlan,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllPaymentPlanMutation,
  useLazyPaymentPlanDetailQuery,
  useLazyDeletePaymentPlanQuery,
  useAddPaymentPlanMutation,
  useUpdatePaymentPlanMutation,
} = paymentPlanApi;
